"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { clientCookies } from "@/lib/clientCookies";
import { emitGTMEvent, getStoredUserInfo } from "./utilities";
interface DatalayerPageViewProps {
  hostname: string;
  locale: string;
  environment: string;
}

// Module-level guard: exactly one dataLayer-initialized push per navigated
// pathname, even when the component remounts (per-page mounts, strict-mode
// double effects) or re-renders with changed hostname/locale/environment props.
let lastTrackedPath: string | null = null;
export const DatalayerPageView = t0 => {
  const $ = _c(6);
  const {
    hostname,
    locale,
    environment
  } = t0;
  const pathname = usePathname();
  let t1;
  let t2;
  if ($[0] !== environment || $[1] !== hostname || $[2] !== locale || $[3] !== pathname) {
    t1 = () => {
      if (!pathname || lastTrackedPath === pathname) {
        return;
      }
      lastTrackedPath = pathname;
      const lang = locale || "";
      const userInfo = getStoredUserInfo();
      const country = locale?.includes("-") && locale.split("-")[1] ? locale.split("-")[1].toUpperCase() : null;
      const business_id = clientCookies.get("_biz_uid");
      const contentful_id = clientCookies.get("contentful_id");
      let franchise_name;
      let division_name;
      let subdivision_name;
      franchise_name = (document.querySelector("meta[name=\"franchise\"]") as HTMLMetaElement | null)?.content;
      if (franchise_name === "undefined") {
        franchise_name = null;
      }
      division_name = (document.querySelector("meta[name=\"division\"]") as HTMLMetaElement | null)?.content;
      if (division_name === "undefined") {
        division_name = null;
      }
      subdivision_name = (document.querySelector("meta[name=\"subdivision\"]") as HTMLMetaElement | null)?.content;
      if (subdivision_name === "undefined") {
        subdivision_name = null;
      }
      const previousPath = window.sessionStorage.getItem("previousPath") || window.location.pathname;
      clientCookies.set("prev_page", previousPath);
      const storedReferrer = window.sessionStorage.getItem("mxp_silent_sso_referrer");
      if (storedReferrer) {
        window.sessionStorage.removeItem("mxp_silent_sso_referrer");
      }
      const currentReferrer = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : null;
      const originalReferrer = storedReferrer || currentReferrer;
      emitGTMEvent({
        event: "dataLayer-initialized",
        page_url: window.location.href,
        page_title: document.title || window.location.pathname,
        original_referrer: originalReferrer,
        locale,
        franchise: franchise_name,
        division: division_name,
        subdivision: subdivision_name,
        business_id,
        contentful_id,
        language: lang,
        environment,
        hostname,
        trimble_id: typeof userInfo?.tid === "string" ? userInfo.tid : userInfo?.tid ?? null,
        logged_in: !!userInfo,
        country
      });
    };
    t2 = [environment, hostname, locale, pathname];
    $[0] = environment;
    $[1] = hostname;
    $[2] = locale;
    $[3] = pathname;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return null;
};
export default DatalayerPageView;